/*
 * @描述: 添加成员
 * @版本: 1.0
 * @作者: 冯强
 * @创建时间: 2025-02-25 17:17:52
 */
<template>
    <el-dialog :before-close="handleDialogClose"
               :close-on-click-modal="false"
               :close-on-press-escape="false"
               :visible.sync="dialogVisible"
               title="添加团队成员"
               width="520px">
        <el-form ref="teamMembersAddForm"
                 :model="teamMembersAddForm"
                 :rules="teamMembersAddFormRules"
                 class="team_members_form"
                 label-position="top"
                 size="small">
            <el-form-item label="选择成员" prop="member">
                <el-select v-model="teamMembersAddForm.member_uid"
                           :remote-method="getUserOptions"
                           filterable
                           placeholder="请选择人员，可输入人员姓名搜索"
                           remote>
                    <el-option v-for="item in userOptions"
                               :key="item.uid"
                               :label="item.name"
                               :value="item.uid"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="权限类型">
                <el-radio-group v-model="teamMembersAddForm.auth">
                    <el-radio :label="1">只读</el-radio>
                    <el-radio :label="2">读写</el-radio>
                </el-radio-group>
            </el-form-item>
        </el-form>
        <div slot="footer">
            <el-button @click="handleDialogClose">取消</el-button>
            <el-button type="primary" @click="handleDialogConfirm">确定</el-button>
        </div>
    </el-dialog>
</template>
<script>
    import {GetUserList, orderMemberAdd} from "@/api";

    export default {
        name: "OrderAddMember",
        data() {
            return {
                teamMembersAddForm: {
                    member_uid: '',
                    auth: 1
                },
                teamMembersAddFormRules: {
                    member_uid: [
                        {required: true, message: '请选择成员', trigger: 'change'}
                    ]
                },
                userOptions: [],
            }
        },
        props: {
            dialogVisible: {
                type: Boolean,
                default: false,
            },
            order_ids: {
                type: Array,
                default: () => []
            }
        },
        created() {
            this.getUserOptions()
        },
        methods: {
            //获取用户列表
            getUserOptions(keyword) {
                GetUserList({keyword}).then(res => {
                    if (res.code === 200) {
                        this.userOptions = res.data || []
                    } else {
                        this.$toast(res.message)
                    }
                })
            },

            // 关闭弹窗
            handleDialogClose() {
                this.$emit('update:dialogVisible', false)
            },

            // 确定
            handleDialogConfirm() {
                this.$refs.teamMembersAddForm.validate(valid => {
                    if (valid) {
                        orderMemberAdd({
                            order_ids: this.order_ids,
                            member_uid: this.teamMembersAddForm.member_uid,
                            auth: this.teamMembersAddForm.auth
                        }).then(res => {
                            if (res.code === 200) {
                                this.$message.success('添加成功')
                                this.$emit('update:dialogVisible', false)
                                this.$emit('refresh')
                            } else {
                                this.$toast(res.message)
                            }
                        })
                    } else {

                    }
                })
            },
        },
    }
</script>
<style lang="scss" scoped>
    .team_members_form {
        padding-bottom: 106px;

        .el-select {
            width: 100%;
        }
    }
</style>